// NOTE: r2.dev is the Cloudflare dev/testing domain.
// In production, set NEXT_PUBLIC_ASSET_BASE_URL to your custom domain
// (e.g. https://assets.example.com) pointing to the same R2 bucket.
// Do NOT put private R2 secrets in NEXT_PUBLIC_ prefixed env vars.
const R2_DEV_FALLBACK_URL = 'https://assets.lips.org.uk';

export const ASSET_BASE_URL = (
  process.env.NEXT_PUBLIC_ASSET_BASE_URL || R2_DEV_FALLBACK_URL
).replace(/\/+$/, '');

/**
 * Resolves a storage key or path to a static asset CDN URL.
 *
 * Rules:
 * - null / undefined / empty string → empty string
 * - full http:// or https:// URLs → returned unchanged
 * - paths starting with "/" → returned unchanged (local /public paths)
 * - storage keys / filenames → `${ASSET_BASE_URL}/${key}`
 */
export function getStaticAssetUrl(key: string | null | undefined): string {
  if (!key) return '';

  if (key.startsWith('http://') || key.startsWith('https://')) {
    return key;
  }

  if (key.startsWith('/')) {
    return key;
  }

  const base = ASSET_BASE_URL.replace(/\/+$/, '');
  const cleanKey = key.startsWith('/') ? key : `/${key}`;

  return `${base}${cleanKey}`;
}
